import { useState, useEffect } from "react";
import { Product, ProductFilters } from "../types/pos.types";
import { posService } from "../../../services/pos.service";

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const response = await posService.listProducts();
        setProducts((response?.data || []) as unknown as Product[]);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to fetch products")
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading, error };
};
